import { useStyles } from './PdfDetails.styles';
import DownloadIcon from '@mui/icons-material/Download';
import { IPdfListItem } from '../../../services/supportPdf/supportPdf.types';
import PdfPageImage from '../../../assets/images/PdfPageImage.png';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { updateDownloadCount, viewPdf } from '../../../services/supportPdf/supportPdf.service';
import { useLayoutContext } from '../../../Context/Layout.context';
import { Grid } from '@material-ui/core';
import EnvWindow from '../../../utils/env';
import { downloadFile } from '../../../utils/servicesHelper';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useState } from 'react';
import Popover from '@mui/material/Popover/Popover';
import Typography from '@mui/material/Typography';
import React from 'react';
import IconButton from '@mui/material/IconButton';

const ELEMENT_ID_DOWNLOAD = 'download';
const ELEMENT_ID_VIEW = 'view';
const RESPONSE_STATUS_OK = 'OK';
const DOM_ELEMENT_ANCHOR = 'a';

interface PdfDetailsProps {
  pdfProp: IPdfListItem;
  deleteFunc: () => void;
  updateFunc: () => void;
  isAdminPermission: boolean;
}

export const PdfDetails: React.FC<PdfDetailsProps> = ({ pdfProp, deleteFunc, updateFunc, isAdminPermission }) => {
  const classes = useStyles();
  const { openAlert, showLoader } = useLayoutContext();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [downloadCount, setDownloadCount] = useState<number>(pdfProp.downloadCount);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'pdf-popover' : undefined;

  const handleViewPdfData = (pdfId: string) => {
    showLoader(true);
    viewPdf(pdfId)
      .then(
        (response) => {
          if (response.statusText == RESPONSE_STATUS_OK) {
            const link = document.createElement(DOM_ELEMENT_ANCHOR);
            link.href = `${response.config.url}/${pdfId}`;

            link.setAttribute('target', '_blank');

            const element = document.getElementById(ELEMENT_ID_VIEW);

            if (element) {
              element.appendChild(link);
            }
            link.click();
          } else {
            () => {
              openAlert('get_error');
            };
          }
        },
        () => openAlert('get_error'),
      )
      .finally(() => {
        showLoader(false);
      });
  };

  const handleDownloadPdfData = (pdfId: string) => {
    downloadFile(`${EnvWindow.REACT_APP_SUPPORT_PDF_API_URL}/Pdf/${pdfId}`, pdfProp.fileName);

    const count = downloadCount + 1;
    updateDownloadCount(pdfId).then(
      (res) => {
        if (res.data) {
          setDownloadCount(count);
        } else {
          () => {
            openAlert('save_error');
          };
        }
      },
      () => openAlert('save_error'),
    );
  };

  return (
    <Grid className={classes.helpdeskMain}>
      <Grid className={classes.helpdeskMainContainer}>
        <img className={classes.helpdeskPicImg} src={PdfPageImage} alt="ikona helpdesk" />
        <Grid className={classes.helpdeskInfoContainer}>
          <h6 className={classes.helpdeskInfoTitle}>
            <Grid id={ELEMENT_ID_VIEW}>
              <div role="button" className={classes.helpdeskButtonView} onClick={() => handleViewPdfData(pdfProp.id)}>
                {pdfProp.title}
              </div>
            </Grid>
          </h6>
          <Grid className={classes.helpdeskInfoSize}>
            {pdfProp.size} {isAdminPermission && `* Liczba pobrań: ${downloadCount}`}
          </Grid>
        </Grid>
      </Grid>

      {isAdminPermission ? (
        <div className={classes.helpdeskButtonsContainer}>
          <div>
            <Popover
              className={classes.helpdeskPopover}
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 15,
                horizontal: -140,
              }}
            >
              <Typography sx={{ p: 2 }}>
                <>
                  <div
                    className={classes.helpdeskButtonsPopoverContainer}
                    onClick={() => {
                      setAnchorEl(null);
                      updateFunc();
                    }}
                  >
                    <button className={classes.helpdeskButton} onClick={handleClose}>
                      <EditOutlinedIcon />
                    </button>
                    <div className={classes.helpdeskButtonSpan}>Edytuj</div>
                  </div>
                  <div
                    className={classes.helpdeskButtonsPopoverContainer}
                    onClick={() => {
                      setAnchorEl(null);
                      deleteFunc();
                    }}
                  >
                    <button className={classes.helpdeskButton} onClick={handleClose}>
                      <DeleteOutlineIcon />
                    </button>
                    <div className={classes.helpdeskButtonSpan}>Usuń</div>
                  </div>
                </>
                <div
                  onClick={() => {
                    handleDownloadPdfData(pdfProp.id);
                    handleClose();
                  }}
                  className={classes.helpdeskButtonsPopoverContainer}
                >
                  <button id={ELEMENT_ID_DOWNLOAD} className={classes.helpdeskButton}>
                    <DownloadIcon />
                  </button>
                  <div className={classes.helpdeskButtonSpan}>Pobierz</div>
                </div>
              </Typography>
            </Popover>
          </div>
          <IconButton
            disableRipple
            color="default"
            aria-describedby={id}
            onClick={handleClick}
            aria-label="akcje na dokumencie"
          >
            <MoreVertIcon></MoreVertIcon>
          </IconButton>
        </div>
      ) : (
        <div
          onClick={() => handleDownloadPdfData(pdfProp.id)}
          className={classes.helpdeskButtonsPopoverContainer}
          style={{ color: '#3560FF', cursor: 'pointer', textDecoration: 'underline' }}
        >
          <button id={ELEMENT_ID_DOWNLOAD} className={classes.helpdeskButton}>
            <DownloadIcon style={{ color: '#3560FF' }} />
          </button>
          <div className={classes.helpdeskButtonSpan}>Pobierz</div>
        </div>
      )}
    </Grid>
  );
};
